import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SymptomField } from '../decoder/SymptomField';
import { AnswerPanel } from '../decoder/AnswerPanel';
import { Eyebrow } from '../ui/Eyebrow';
import { useSymptomSelection } from '../../hooks/useSymptomSelection';
export function DecoderTeaser() {
  const {
    selected,
    toggle
  } = useSymptomSelection();
  return <section className="bg-cream-light" aria-labelledby="decoder-heading" data-id="element-148" data-mp="qiyyor97t7ov">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-149" data-mp="lj4baxonf08k">
        <Eyebrow className="text-brick" data-id="element-150" data-mp="gqb505dj7jud">The symptom decoder</Eyebrow>
        <div className="mt-5 grid gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-end lg:gap-20" data-id="element-151" data-mp="brzv5un8l9c5">
          <h2 id="decoder-heading" className="max-w-2xl font-serif text-4xl leading-[1.05] text-ink md:text-[3.25rem]" data-id="element-152" data-mp="bq5ggy2k6dgi">
            Tell us what you’re feeling. We’ll tell you what’s happening.
          </h2>
          <p className="max-w-xl leading-relaxed text-ink-soft" data-id="element-153" data-mp="qdauotsw722q">
            Pick anything that sounds like you. The answer appears here, immediately, before you
            give us anything — no email, no account, no results held behind a signup.
          </p>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16" data-id="element-154" data-mp="lkzt7mii7882">
          <SymptomField selected={selected} onToggle={toggle} groups={['mind', 'sleep']} data-id="element-155" data-mp="6o8s98t6logc" />

          <div data-id="element-156" data-mp="6qlfo1hpkr0s">
            <AnimatePresence mode="wait" initial={false} data-id="element-157" data-mp="bn3n594fb3gt">
              {selected.length === 0 ? <EmptyInvitation key="empty" data-id="element-158" data-mp="3tthwsvvnsr9e" /> : <AnswerPanel key="answer" selected={selected} limit={2} data-id="element-159" data-mp="3tv1aqftueq80" />}
            </AnimatePresence>

            <Link to="/symptoms" className="group mt-8 inline-flex items-center gap-2 font-serif text-xl text-brick transition-colors duration-150 ease-brand hover:text-brick-deep" data-id="element-160" data-mp="1s1ljphtuf9ci">
              {selected.length > 0 ? 'Open the full decoder — your selections come with you' : 'Open the full decoder — all five categories'}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-161" data-mp="1llbqsyw7yqx6" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}
function EmptyInvitation() {
  return <div className="rounded-brand border border-dashed border-ink/25 bg-cream p-8 md:p-12" data-id="element-162" data-mp="29b60x8p5m1dq">
      <p className="font-serif text-2xl leading-snug text-ink md:text-3xl" data-id="element-163" data-mp="24k7h3z4yil5q">
        Pick one. Even the one you have never said out loud.
      </p>
      <p className="mt-5 max-w-md leading-relaxed text-ink-soft" data-id="element-164" data-mp="1zkbeo4bwr1sa">
        Most women start with sleep or with the rage. There is no wrong order, and nothing you
        select is stored or sent anywhere.
      </p>
    </div>;
}